import React from 'react';
import { Link } from 'react-router-dom';

const SupportPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Техническая поддержка</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Как мы можем помочь?</h2>
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-2">Консультации</h3>
              <p>Наши специалисты готовы ответить на любые вопросы по оборудованию и его эксплуатации</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-2">Документация</h3>
              <p>Доступ к технической документации, инструкциям и схемам</p>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Контакты поддержки</h2>
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold mb-2">Горячая линия</h3>
                <p>Телефон: <a href="tel:88002505710" className="text-primary hover:underline">8 800 250 57 10</a></p>
                <p><a href="tel:79266929899" className="text-primary hover:underline">+7 926 692 98 99</a></p>
                <p><a href="tel:79653957895" className="text-primary hover:underline">+7 965 395 78 95</a></p>
                <p className="text-sm text-gray-600">Пн-Пт: 9:00 - 18:00</p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Email поддержка</h3>
                <p><a href="mailto:info@teplogrand.pro" className="text-primary hover:underline">info@teplogrand.pro</a></p>
                <p className="text-sm text-gray-600">Ответ в течение 24 часов</p>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <h2 className="text-2xl font-semibold mb-4">База знаний</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
              <ul className="space-y-4">
                <li>
                  <Link 
                    to="/video-tutorials" 
                    className="text-primary hover:underline flex items-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Видео уроки
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/bim-models" 
                    className="text-primary hover:underline flex items-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    BIM-модель
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage; 